import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { AuthProvider } from "./auth/AuthProvider";
import "./index.css";
import rootStore from "./stores/rootStore";
import './i18n/i18n';
import App from "./views/App";

ReactDOM.render(
    <React.StrictMode>
        <Provider store={rootStore()}>
            <AuthProvider>
                <App />
            </AuthProvider>
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);
